import { combineReducers } from 'redux';
import userProfile from './reducers/user-profile';

export default combineReducers({
  userProfile,
});
